import { httpCreate } from './http';

const http = httpCreate('/srv/authorize');

export const authorize = {
	// pageNum, pageSize
	getAuthorPage(params) {
		return http.get('', { params });
	},
	add(data) {
		return http.post('/add', data);
	},
	// pageNum, pageSize, username
	getAuthorByUname(params) {
		return http.get('/getByParam', { params });
	},
	//pageNum, pageSize, userId
	getAuthorById(params) {
		return http.get('/getByUId', { params });
	},
	deleteAuthor(data) {
		return http.post('', data);
	},
	//pageNum, pageSize
	getOrderListInvoice(data, params) {
		return http.post('/getByUId', data, { params });
	}
};
